import { createApp } from "vue"
import MembersSelector from "../components/MembersSelector.vue"

const mountedApps = new WeakMap()
const memberSelectorQuery = "[data-vue-household-members-selector]"

function mountVueApp(element, component, props) {
  if (mountedApps.has(element)) return

  const app = createApp(component, props)
  app.mount(element)
  mountedApps.set(element, app)
}

function mountMemberSelectors() {
  document.querySelectorAll("[data-vue-household-members-selector]").forEach((element) => {
    const initialSelectedIds = JSON.parse(element.dataset.selectedIdsValue || "[]")

    mountVueApp(element, MembersSelector, {
      members: JSON.parse(element.dataset.membersValue || "[]"),
      initialSelectedIds: Array.isArray(initialSelectedIds) ? initialSelectedIds : [],
      noResultsText: element.dataset.noResultsText,
      removeText: element.dataset.removeText,
      searchLabel: element.dataset.searchLabel,
      searchPlaceholder: element.dataset.searchPlaceholder
    })
  })
}

function unmountMemberSelectors() {
  document.querySelectorAll(memberSelectorQuery).forEach((element) => {
    unmountVueApp(element)
  })
}

function unmountMemberSelectorsInside(container) {
  if (container.matches(memberSelectorQuery)) {
    unmountVueApp(container)
  }

  container.querySelectorAll(memberSelectorQuery).forEach((element) => {
    unmountVueApp(element)
  })
}

function unmountVueApp(element) {
  const app = mountedApps.get(element)
  if (!app) return

  app.unmount()
  mountedApps.delete(element)
}

document.addEventListener("turbo:load", mountMemberSelectors)
document.addEventListener("turbo:before-cache", unmountMemberSelectors)
document.addEventListener("turbo:frame-load", mountMemberSelectors)
document.addEventListener("turbo:before-stream-render", (event) => {
  const targetId = event.target.getAttribute("target")
  const target = targetId ? document.getElementById(targetId) : null
  if (target) unmountMemberSelectorsInside(target)

  const render = event.detail.render
  event.detail.render = (streamElement) => {
    render(streamElement)
    mountMemberSelectors()
  }
})
mountMemberSelectors()
